<template>
    <div class="assignment">
        <div class="assignment-type-question-answer" v-if="partIn.type_name === 'assignment_question'">
            <div class="assignment-question">
                <div class="title">
                    <div
                        class="add-answer-to-profile"
                        v-if="canAddToProfile">
                        <b-button
                            class="btn-user-add btn-add-to-user-profile"
                            :v-b-tooltip="$t('assignment.add_to_timeline')"
                            v-b-modal="'assignment-add-profile-card-modal-' + partIn.id"
                            variant="primary-icon-only">
                        </b-button>
                    </div>

                    {{ partIn.name ? partIn.name : partIn.getNameOrder() }}
                </div>

                <design-2021-apprentice-display-html-component
                    class="assignment-sub-question"
                    v-if="partIn.text.value"
                    :html-content="partIn.text.value"></design-2021-apprentice-display-html-component>
            </div>

            <design-2021-assignment-show-answer-question-component
                :part-in="partIn"
                :can-answer="canAnswer"
                :project-id="projectId">
            </design-2021-assignment-show-answer-question-component>
        </div>

        <div class="assignment-type-question-answer" v-if="partIn.type_name === 'assignment_fill_in_the_blanks'">
            <div class="assignment-question">
                <div class="title">
                    {{ partIn.name ? partIn.name : partIn.getNameOrder() }}
                </div>

                <design-2021-apprentice-display-html-component
                    class="assignment-sub-question"
                    v-if="partIn.text.value"
                    :html-content="partIn.text.value">
                </design-2021-apprentice-display-html-component>
            </div>

            <design-2021-assignment-show-fill-in-the-blanks-component
                :part-in="partIn"
                :can-answer="canAnswer"
                :project-id="projectId">
            </design-2021-assignment-show-fill-in-the-blanks-component>
        </div>

        <div class="assignment-type-list-options" v-if="partIn.type_name === 'assignment_matching_list'">
            <div class="assignment-question">
                <div class="title">
                    {{ partIn.name ? partIn.name : partIn.getNameOrder() }}
                </div>

                <design-2021-apprentice-display-html-component
                    class="assignment-sub-question"
                    v-if="partIn.text.value"
                    :html-content="partIn.text.value">
                </design-2021-apprentice-display-html-component>
            </div>

            <design-2021-assignment-show-matching-list-component
                :part-in="partIn" :can-answer="canAnswer"
                :is-example-in="isExampleIn"
                :ords="true"
                :project-id="projectId">
            </design-2021-assignment-show-matching-list-component>
        </div>

        <div
            class="assignment-type-file-upload"
            v-if="partIn.isAssignmentFileUpload()">
            <div class="assignment-question">
                <div class="title">
                    <div
                        class="add-answer-to-profile"
                        v-if="canAddToProfile">
                        <b-button
                            class="btn-user-add btn-add-to-user-profile"
                            :v-b-tooltip="$t('assignment.add_to_timeline')"
                            v-b-modal="'assignment-add-profile-card-modal-' + partIn.id"
                            variant="primary-icon-only">
                        </b-button>
                    </div>

                    {{ partIn.name ? partIn.name : partIn.getNameOrder() }}
                </div>

                <design-2021-apprentice-display-html-component
                    class="assignment-sub-question"
                    v-if="partIn.text.value"
                    :html-content="partIn.text.value"></design-2021-apprentice-display-html-component>

                <div class="file-upload-info text-danger">{{ $t('files.maximum_upload_size_is') }} 3000mb.</div>
            </div>

            <design-2021-assignment-show-answer-upload-component
                :part-in="partIn"
                :can-answer="canAnswer"
                :project-id="projectId">
            </design-2021-assignment-show-answer-upload-component>
        </div>

        <div
            class="assignment-type-text"
            v-if="partIn.isAssignmentText()">
            <div class="assignment-question">
                <div class="title">
                    <div
                        class="add-answer-to-profile"
                        v-if="canAddToProfile">
                        <b-button
                            class="btn-user-add btn-add-to-user-profile"
                            :v-b-tooltip="$t('assignment.add_to_timeline')"
                            v-b-modal="'assignment-add-profile-card-modal-' + partIn.id"
                            variant="primary-icon-only">
                        </b-button>
                    </div>

                    {{ partIn.name ? partIn.name : partIn.getNameOrder() }}
                </div>

                <design-2021-apprentice-display-html-component
                    class="assignment-sub-question"
                    v-if="partIn.text.value"
                    :html-content="partIn.text.value">
                </design-2021-apprentice-display-html-component>
            </div>

            <design-2021-assignment-show-answer-text-component
                :part-in="partIn"
                :can-answer="canAnswer"
                :project-id="projectId">
            </design-2021-assignment-show-answer-text-component>
        </div>

        <div
            class="assignment-type-editor"
            v-if="partIn.isAssignmentEditor()">
            <div class="assignment-question">
                <div class="title">
                    <div
                        class="add-answer-to-profile"
                        v-if="canAddToProfile">
                        <b-button
                            class="btn-user-add btn-add-to-user-profile"
                            :v-b-tooltip="$t('assignment.add_to_timeline')"
                            v-b-modal="'assignment-add-profile-card-modal-' + partIn.id"
                            variant="primary-icon-only">
                        </b-button>
                    </div>

                    {{ partIn.name ? partIn.name : partIn.getNameOrder() }}
                </div>

                <design-2021-apprentice-display-html-component
                    class="assignment-sub-question"
                    v-if="partIn.text.value"
                    :html-content="partIn.text.value"></design-2021-apprentice-display-html-component>
            </div>

            <design-2021-assignment-show-answer-editor-component
                :part-in="partIn"
                :can-answer="canAnswer"
                :project-id="projectId">
            </design-2021-assignment-show-answer-editor-component>
        </div>

        <div
            class="assignment-type-list"
            v-if="partIn.isAnAssignmentList()">
            <div class="assignment-question">
                {{ partIn.name ? partIn.name : partIn.getNameOrder() }}
                <design-2021-apprentice-display-html-component
                    class="assignment-sub-question"
                    v-if="partIn.text.value"
                    :html-content="partIn.text.value"></design-2021-apprentice-display-html-component>
            </div>

            <design-2021-assignment-show-answer-list-component
                :part-in="partIn"
                :can-answer="canAnswer"
                :is-example-in="isExampleIn"
                :group-type-id-in="groupTypeIdIn"
                :project-id="projectId">
            </design-2021-assignment-show-answer-list-component>
        </div>

        <design-2021-assignment-show-add-to-profile-modal-component
            :is-coop-in="isCoopIn"
            :part="partIn"
            :profile-categories-in="profileCategoriesIn"
            :project-id="projectId">
        </design-2021-assignment-show-add-to-profile-modal-component>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-assignment-show-assignment-part-component',
        props: ['partIn', 'canAnswer', 'projectId', 'profileCategoriesIn', 'isExampleIn', 'isCoopIn', 'groupTypeIdIn'],
        data() {
            return {
                viewType: null,
                isStudentOrAdmin: !!(this.$authUser.isStudent() || this.$authUser.isAdmin())
            };
        },
        computed: {
            canAddToProfile() {
                return !!(this.isStudentOrAdmin && this.partIn.canAddToProfile());
            }
        }
    };
</script>

<style scoped lang="scss">
    .assignment {
        padding: map-get($grid-gutter-spacing, 'twenty-one');
        background-color: $secondary-background-color;
        border-radius: $border-radius-content;
        clear: both;
    }

    .assignment-type-question-answer,
    .assignment-type-file-upload,
    .assignment-type-text,
    .assignment-type-editor,
    .assignment-type-list {
        .assignment-question {
            color: var(--primary);
            font-size: 1.3125rem;

            .assignment-sub-question {
                font-size: $default-font-size;
                color: $text-color;
            }

            .title {
                font-weight: $font-weight-bold;
            }
        }
    }

    .assignment-question {
        .btn-add-to-user-profile {
            padding: map-get($grid-gutter-spacing, 'eight');
            font-size: 1.125rem;
            border: 1px solid var(--primary);

            &:hover {
                background-color: var(--primary);
                color: $white;
            }
        }

        .title {
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: flex-start;
            margin-bottom: map-get($grid-gutter-spacing, 'eight');

            .add-answer-to-profile {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }

    .file-upload-info {
        font-size: $default-font-size;
    }
</style>
